module.exports = __webpack_public_path__ + "img/research.1d141002.svg";